import { useProtocolsSpecies } from '@/hooks/api'
import { useMemo } from 'react'
import { Specie } from '@/types'

export const useProtocolSpeciesOptions = <T = number>(
  fullObjectValue = false
): {
  speciesList: Specie[] | undefined
  speciesOptions: { value: T; title: string }[]
  mapSpecieToOption: (specie: Specie) => { value: T; title: string }
} => {
  const { data: speciesList } = useProtocolsSpecies()

  const speciesOptions = useMemo(() => {
    if (speciesList?.length) {
      return speciesList.map((specie) => ({
        value: (fullObjectValue ? { ...specie } : specie.id) as T,
        title: `[${specie.animal.name}] ${specie.name}`,
      }))
    } else return []
  }, [speciesList])

  const mapSpecieToOption = (specie: Specie): { value: T; title: string } => ({
    value: (fullObjectValue ? { ...specie } : specie.id) as T,
    title: `[${specie.animal.name}] ${specie.name}`,
  })

  return { speciesList, speciesOptions, mapSpecieToOption }
}
